type HourLinesProps = {
  labels: string[];
  totalSegmentWidth: number;
  marginX: number;
  boardHeight: number;
  hideLabels?: boolean;
};

export const HourLines = ({
  labels,
  totalSegmentWidth,
  marginX,
  boardHeight,
  hideLabels = false,
}: HourLinesProps) => {
  return (
    <g id="hour-lines-group">
      {[...Array(5)].map((_, i) => {
        const lineX = (totalSegmentWidth / 4) * i;
        const lineTopY = hideLabels ? 0 : 12;

        const textY = 10;

        return (
          <g key={`hour-marker-${i}`}>
            {!hideLabels && (
              <text
                x={marginX + lineX}
                y={textY}
                textAnchor="middle"
                fill="#222"
                fontSize="12"
                style={{ userSelect: 'none' }}
              >
                {labels[i]}
              </text>
            )}

            <line
              x1={marginX + lineX}
              y1={lineTopY}
              x2={marginX + lineX}
              y2={boardHeight}
              stroke="#222"
              strokeWidth="1"
              strokeDasharray="5,5" // define the dotted lines (5px trait, 5px whitespace)
              pointerEvents="none"
            />
          </g>
        );
      })}
    </g>
  );
};
